import { Navbar } from "@/components/landing/Navbar";
import { FooterSection } from "@/components/landing/FooterSection";
import { buildProviderSlug } from "@/lib/provider-slug";

export type IntentShellProps = {
 title: string;
 description: string;
 h1: string;
 intro: string;
 emptyMessage: string;
 providers: Array<{
 id: string;
 public_id?: string | null;
 name: string | null;
 credentials?: string | null;
 practice?: string | null;
 specialty?: string | null;
 city?: string | null;
 state?: string | null;
 }>;
 breadcrumbs: Array<{ label: string; href?: string }>;
};

export function IntentPageShell({ h1, intro, emptyMessage, providers, breadcrumbs }: IntentShellProps) {
 return (
 <div className="min-h-screen bg-background">
 <Navbar />
 <main className="mx-auto max-w-5xl px-6 py-16">
 <nav className="text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
 {breadcrumbs.map((b, i) => (
 <span key={i}>
 {b.href ? (
 <a href={b.href} className="hover:text-foreground">{b.label}</a>
 ) : (
 <span className="text-foreground">{b.label}</span>
 )}
 {i < breadcrumbs.length - 1 ? <span className="mx-2">/</span> : null}
 </span>
 ))}
 </nav>

 <header className="mb-8">
 <h1 className="text-3xl md:text-4xl font-semibold tracking-tight text-foreground">{h1}</h1>
 <p className="mt-3 text-muted-foreground max-w-2xl">{intro}</p>
 </header>

 {providers.length === 0 ? (
 <div className="border border-dashed border-border bg-card p-8 text-center">
 <p className="text-sm text-muted-foreground">{emptyMessage}</p>
 </div>
 ) : (
 <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3 mb-12">
 {providers.map((p) => {
 const slug = buildProviderSlug(p as any);
 const name = (p.name || p.practice || p.specialty || "Provider").trim();
 const creds = (p.credentials || "").trim();
 return (
 <li key={p.id} className="text-sm">
 <a href={`/providers/${slug}`} className="text-foreground hover:text-primary hover:underline">
 {creds ? `${name}, ${creds}` : name}
 </a>
 {p.city && p.state ? (
 <span className="text-muted-foreground">, {p.city}, {p.state}</span>
 ) : null}
 </li>
 );
 })}
 </ul>
 )}
 </main>
 <FooterSection />
 </div>
 );
}
